document.addEventListener('DOMContentLoaded', function () {
    const detailsTags = document.querySelectorAll('.accordion');

    detailsTags[1]?.setAttribute('open', 'true');

    detailsTags.forEach(detailsTag => {
    detailsTag.addEventListener('click', () => {
        detailsTags.forEach(otherDetailsTag => {
        if (otherDetailsTag !== detailsTag) {
            otherDetailsTag.removeAttribute('open');
        }
        });
    });
    });
});

$(document).ready(function(){
    function recall(){
        if($('.complementary-products__product-list').length > 0){
            const swiper = new Swiper('.mySwiper', {
                slidesPerView: 1,      // ✅ 1 slide at a time
                spaceBetween: 0,
                loop: true,            // ✅ infinite scroll
                speed: 500,

                navigation: {
                nextEl: '.swiper-btn-next',
                prevEl: '.swiper-btn-prev',
                },

                grabCursor: true,      // nice UX
                touchRatio: 1,
            });
        }else{
            setTimeout(function(){
                recall();
            },1000);
        }
    }
    recall();

    function fetchUpdatedOption2Labels(handle, variantId, productEl) {
    fetch(`/products/${handle}?variant=${variantId}`)
    .then(res => res.text())
    .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // CURRENT options in DOM
        const currentOptions = productEl.querySelectorAll('.variant-picker__option');

        // NEW options from fetched HTML
        const newOptions = doc.querySelectorAll('.variant-picker__option');

        if (!currentOptions.length || !newOptions.length) return;

        currentOptions.forEach((currentOption, index) => {
        const currentSelector = currentOption.querySelector('[data-option-selector]');
        const newSelector = newOptions[index]?.querySelector('[data-option-selector]');

        if (currentSelector && newSelector) {
            // 🔥 Replace ONLY option values HTML
            currentSelector.innerHTML = newSelector.innerHTML;
        }
        });

        // ✅ Remove loader after update
        // productEl
        // .querySelectorAll('.block-swatch.loading, .media-swatch.loading')
        // .forEach(el => el.classList.remove('loading'));
    })
    .catch(err => console.error('Variant options update failed:', err));

    }

    document.addEventListener("variant:change", function (event) {
        const variant = event.detail.variant;
        const form = event.target;

        if (!variant || !form) return;

        const productHandle = form.getAttribute("product-handle");
        const productEl = form.closest(".product-info");

        if (!productHandle || !productEl) return;
        // $(productEl).find('.variant-picker__option + .variant-picker__option .block-swatch').addClass('loading');
        fetchUpdatedOption2Labels(productHandle, variant.id, productEl);
    });

    
});